// extracted by mini-css-extract-plugin
export default {"defaultButtonStyle":"ErgoButton_defaultButtonStyle__gnxUV","buttonTextStyle":"ErgoButton_buttonTextStyle__z-kKz"};